import { lazy } from 'react';
import { adaptiveCenterModalOptions } from '../../appComponents/ModalWrapper';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

const ShopifyVideoClipPageContent = lazy(
  () => import('./ShopifyVideoClipPageContent'),
);

export const ShopifyClipsPage = wrapLazyNavigatorScreen(
  ShopifyVideoClipPageContent,
  adaptiveCenterModalOptions(),
);
